import MicroModal from "micromodal";
import React from "react";

import { ReactComponent as IconClose } from "../../../../build/images/attendanceIcons/close-side-info.svg";

import "./quarantine-modal.styles.css";

const QuarantineModal = ({ onConfirm = () => {} }) => {
  function closeModal() {
    MicroModal.close("modal__quarantine-zone");
  }

  return (
    <div
      className="modal micromodal-slide"
      id="modal__quarantine-zone"
      aria-hidden="true"
      role="dialog"
    >
      <div className="modal__overlay" tabIndex="-1">
        <div
          className="modal__container"
          role="dialog"
          aria-modal="true"
          aria-labelledby="modal__linkAdd-contact__title"
        >
          <div className="quarantine-modal-content">
            <header className="quarantine-modal-content__header">
              <h1>Mover para Standby</h1>
              <button onClick={closeModal}>
                <IconClose />
              </button>
            </header>
            <p className="quarantine-modal-content__text">
              Você tem certeza que deseja mover esta conversa para o Standby?
            </p>
            <footer className="quarantine-modal-content__footer">
              <button
                className="quarantine-modal-content__footer__btn-cancel"
                onClick={closeModal}
              >
                Cancelar
              </button>
              <button
                className="quarantine-modal-content__footer__btn-move"
                onClick={() => {
                  onConfirm();
                  closeModal();
                }}
              >
                Mover
              </button>
            </footer>
          </div>
        </div>
      </div>
    </div>
  );
};

export default QuarantineModal;
